(function () {
  function makeBadge(modifier, text) {
    var span = document.createElement('span');
    span.className = 'brutal-card__stock-badge brutal-card__stock-badge--' + modifier;
    span.setAttribute('data-stock-badge', '');
    span.textContent = text;
    return span;
  }

  function updateBadge(productItem, swatchInput) {
    var container = productItem.querySelector('[data-stock-badges]');
    if (!container) return;

    var managed = swatchInput.getAttribute('data-variant-inventory-managed') === 'true';
    var qty = parseInt(swatchInput.getAttribute('data-variant-inventory'), 10);
    var available = swatchInput.getAttribute('data-variant-available') === 'true';
    var showOut = container.getAttribute('data-show-out-of-stock') === 'true';
    var mode = container.getAttribute('data-stock-mode') || 'always';
    var lowThreshold = parseInt(container.getAttribute('data-low-threshold'), 10);
    var hideSelectedOut = container.getAttribute('data-hide-selected-variant-oos') === 'true';
    if (isNaN(lowThreshold) || lowThreshold < 1) lowThreshold = 1;

    if (mode === 'never') {
      while (container.firstChild) container.removeChild(container.firstChild);
      container.style.display = 'none';
      return;
    }

    if (hideSelectedOut && !available) {
      while (container.firstChild) container.removeChild(container.firstChild);
      container.style.display = 'none';
      return;
    }

    var badge = null;
    if (managed) {
      if (mode === 'always') {
        if (qty > 1) {
          badge = makeBadge('in-stock', 'IN STOCK (' + qty + ')');
        } else if (qty === 1) {
          badge = makeBadge('last-one', 'ONLY 1 LEFT');
        } else if (showOut) {
          badge = makeBadge('out', 'OUT OF STOCK');
        }
      } else {
        if (qty > 0 && qty <= lowThreshold) {
          badge = makeBadge('last-one', qty === 1 ? 'ONLY 1 LEFT' : 'ONLY ' + qty + ' LEFT');
        } else if (qty <= 0 && showOut) {
          badge = makeBadge('out', 'OUT OF STOCK');
        }
      }
    } else if (mode === 'always' && available) {
      badge = makeBadge('in-stock', 'IN STOCK');
    } else if (!available && showOut) {
      badge = makeBadge('out', 'OUT OF STOCK');
    }

    while (container.firstChild) container.removeChild(container.firstChild);
    if (badge) {
      container.appendChild(badge);
      container.style.display = '';
    } else {
      container.style.display = 'none';
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('color-swatch__radio')) return;
    if (input.getAttribute('data-variant-inventory') === null) return;
    var productItem = input.closest('.product-item');
    if (!productItem) return;
    updateBadge(productItem, input);
  });
})();
